<script setup lang="ts">
import TaxForm from '@/modules/investing/components/tax-form.vue'

const props = defineProps<{
  form: any
  v$: any
}>()

defineExpose({
  isValid: async () => {
    const fields = ['is_filing_required', 'not_filing_reason']
    const results = await Promise.all(fields.filter((f) => props.v$[f]).map((f) => props.v$[f].$validate()))
    return results.every(Boolean)
  },
})
</script>

<template>
  <div>
    <TaxForm :modelValue="form" :v$="v$" />
  </div>
</template>
